import authConfig from '../auth/authConfig'

export default async function userSubmit(data) {
	const USER_SINPOL_POST_ENDPOINT = "/o/c/usersinpols/";

	try {
		const tokenHeaders = new Headers();
		tokenHeaders.append(
			"Content-Type",
			"application/x-www-form-urlencoded"
		);

		const tokenParams = new URLSearchParams();
		tokenParams.append("grant_type", "client_credentials");
		tokenParams.append("client_id", authConfig.clientId);
		tokenParams.append("client_secret", authConfig.clientSecret);

		const requestOptions = {
			method: "POST",
			headers: tokenHeaders,
			body: tokenParams,
			redirect: "follow",
		};

		const responseToken = await fetch(
			authConfig.tokenEndpoint,
			requestOptions
		);

		const tokenData = await responseToken.json();
		const token = tokenData.access_token;

		const response = await fetch(`${USER_SINPOL_POST_ENDPOINT}`, {
			body: JSON.stringify(data),
			method: "POST",
			headers: {
				'Authorization': `Bearer ${token}`,
				"Content-Type": "application/json",
				"accept-language": "pt-BR,pt;q=0.9",
			},
		});

		const responseData = await response.json();

		if (!response.ok) {
			console.error(`Error to send user data: ${responseData.title}`);
			return {
				error: true,
				status: responseData.status || "Unknown status",
				message: responseData.title || JSON.parse(responseData.detail)[0].errorMessage || "Unknown error",
			};
		}

		return responseData;
	} catch (error) {
		console.error("Error posting user:", error);
		return {
			error: true,
			message:
				error.message || "Unknown error occurred during submission",
		};
	}
}
